
export enum CustomerOrderStatus
{
    None = 0,
    Pending = 162,
    InQueue = 262,
    InPreparation = 362,
    Prepared = 462,
    Delivery = 562,
    Cancel = 662
}


export enum CustomerDeliveryOrderStatus
{
    None = 0,
    Draft = 163,
    Waiting = 263,
    OrderReady = 363,
    InTransport = 463,
    InDelivery = 563,
    OrderInShop = 663,
    Delivered = 763,
    Cancel = 863,
}

export enum PaymentTypes {
    Cash = 110,
    Paypal = 210,
    Card = 310,
    Bizum = 410,
    GooglePay = 510,
    CardWeb = 610,
}

export enum PaymentStatus
{
    None = 0,
    Waiting = 111,
    PayOk = 211,
    PayDenied = 311,
    Cancel = 411,
}
export enum LocationsTypes
{
	Online=651,
    Global=151,
    Warehouse=251,
    Shop=351,
	ShopVirtual=451,
	Furniture = 551
}